var _rect, _rect2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef, memo } from "react";
var SvgCheck = function SvgCheck(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    width: 14,
    height: 10,
    viewBox: "0 0 14 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet",
    ref: ref,
    "aria-labelledby": titleId
  }), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4.71094,
    y: 9.44709,
    width: 5.31095,
    height: 0.680768,
    rx: 0.340384,
    transform: "rotate(-135 4.71094 9.44709)",
    stroke: "#CF1409",
    strokeWidth: 0.680768
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: -0.481376,
    width: 11.9049,
    height: 0.680768,
    rx: 0.340384,
    transform: "matrix(0.707107 -0.707107 -0.707107 -0.707107 4.47993 9.10671)",
    stroke: "#CF1409",
    strokeWidth: 0.680768
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCheck);
var Memo = /*#__PURE__*/memo(ForwardRef);
export default Memo;